import {FormattedMessage} from "react-intl";
import React, {useEffect, useState} from "react";
import {localStorageWrapper} from "@commons/infra/localstorage";
import {InformationModal} from "@commons/infra/component/InformationModal";
import {FormBackButton, FormButtonsContainer, FormProceedButton} from "@commons/uinew/component/forms";
import {CustomFormattedMessage} from "@commons/infra/component/CustomFormattedMessage";
import {posthogWrapper} from "@commons/infra/thirdparty/posthog";
import {connect} from "react-redux";
import {Confetti} from "@commons/uinew/confetti";
import {toast} from "react-toastify";
import {SuccessToast} from "../../../../infra/component/Toast";

let PROMO_MODAL_LOCAL_STORAGE_KEY = 'promo_modal_1-seen'
let PROMO_CODE = "MEDON10"

let PromocodeGiveawayPopup = ({authentication, controls, delay = 5_000}) => {
    let [showPromoCode, setShowPromoCode] = useState()

    let onSubmit = () => {
        setShowPromoCode(true)
        posthogWrapper.capture("promocode_giveaway.modal.promocode_shown")
        Confetti.lazyLaunchRealistic()
    }

    let dontShowAgain = () => {
        localStorageWrapper.set(PROMO_MODAL_LOCAL_STORAGE_KEY, true, 1_000 * 60 * 60 * 12)
    }

    let onClose = (e) => {
        posthogWrapper.capture("promocode_giveaway.modal.explicitly_closed")
        if (e) {
            e.preventDefault()
        }
        dontShowAgain()
        controls.hide()
    }

    useEffect(() => {
        if (authentication.isUpdating || authentication.isAuthenticated) {
            return
        }
        if (localStorageWrapper.get(PROMO_MODAL_LOCAL_STORAGE_KEY)) {
            return
        }

        let timeout = setTimeout(() => {
            posthogWrapper.capture("promocode_giveaway.modal.shown")
            controls.show()
        }, delay)

        return () => clearTimeout(timeout)
    }, [authentication]);

    let copyPromoCode = () => {
        navigator.clipboard.writeText(PROMO_CODE);
        toast(<SuccessToast text={"Kods nokopēts!"}/>)
    }

    return <InformationModal
        size={'lg'}
        controls={controls}
        hideHeader={true}
        showCloseButton={false}
        staticBackdrop={true}
        onHide={(e) => {
            onClose(e, "closed_using_backdrop")
        }}
        body={<>
            <div className={"row"}>
                <div className={"col-12 col-lg-4 d-none d-lg-block"}>
                    <img alt={"Lady with phone"} src={"/img/promo-modal/lady-with-phone.png"}/>
                </div>
                <div className={"col-12 col-lg-8 px-0 ps-lg-3 d-flex flex-column justify-content-center"}>
                    <h3>
                        <CustomFormattedMessage id={"promocode-giveaway.popup.title"}/>
                    </h3>

                    <CustomFormattedMessage
                        defaultMessage={"Piekrīti saņemt noderīgu informāciju no Medon un konsultējies ar atlaidi!"}
                        id={"promocode-giveaway.popup.text"}/>

                    {showPromoCode && <div className={"d-flex flex-row align-items-center"}>
                        <div className={"display-5 font-monospace text-black"}>
                            {PROMO_CODE}
                        </div>
                        <button onClick={copyPromoCode} className={"btn btn-secondary btn-sm px-3 ms-2"}>
                            <i className={"ai ai-copy"}/>
                        </button>
                    </div>}

                    <FormButtonsContainer>
                        {!showPromoCode && <FormProceedButton onClick={onSubmit} aiIcon={"eye"}>
                            <FormattedMessage id={"promocode-giveaway.popup.buttons.continue"}/>
                        </FormProceedButton>}
                        <FormBackButton className={showPromoCode && "btn btn-secondary"}
                                        onClick={e => onClose(e, "explicitly_closed")}>
                            <i className={"ai ai-cross me-1"}/>
                            {!showPromoCode && <FormattedMessage id={"promocode-giveaway.popup.buttons.close"}/>}
                            {showPromoCode && <FormattedMessage id={"common.close"}/>}
                        </FormBackButton>
                    </FormButtonsContainer>
                </div>
            </div>
        </>}/>
}

const mapStateToProps = (state) => ({
    authentication: state.authentication
});

export default connect(mapStateToProps)(PromocodeGiveawayPopup)
